
<div class="approval-list__card">
  <table mat-table matSort [dataSource]="dataSource">

    <ng-container matColumnDef="InstrumentNo" >
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="__view_heading" > Instrument No </th>
      <td mat-cell *matCellDef="let element">{{element.InstrumentNo}}</td>
    </ng-container>

    <ng-container matColumnDef="InstrumentDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="__view_heading"> Instrument Date </th>
      <td mat-cell *matCellDef="let element"> {{element.InstrumentDate}} </td>
    </ng-container>

    <ng-container matColumnDef="InstrumentType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Instrument Type </th>
      <td mat-cell *matCellDef="let element"><span class="approval-list__chip">{{element.InstrumentType}}</span></td>
    </ng-container>

    <ng-container matColumnDef="AmountReceived" >
      <th mat-header-cell *matHeaderCellDef> Amount Received </th>
      <td mat-cell *matCellDef="let element"><span class="approval-list__amount">{{element.AmountReceived}}</span></td>
    </ng-container>

    <ng-container matColumnDef="Adjust">
      <th mat-header-cell *matHeaderCellDef> Adjust </th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-icon>dialpad</mat-icon>
            <span>Redial</span>
          </button>
          <button mat-menu-item>
            <mat-icon>notifications_off</mat-icon>
            <span>Disable alerts</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>